module.exports = __webpack_public_path__ + "media/images/ceremony/plans/3/hall-list/plan-ceremony-lineup-kansai-3-9de60c20dfee3458e43ee82e1b24b261.png";